import { render, staticRenderFns } from "./AudienceEditor.vue?vue&type=template&id=110a6706&"
import script from "./AudienceEditor.vue?vue&type=script&lang=ts&"
export * from "./AudienceEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports